<template>
  <base-module
    :installed="false"
    :error="motorStatus.highTemperature"
    :content-active="
      !motorStatus.overcurrent &&
      !motorStatus.stalled &&
      !motorStatus.highTemperature
    "
  >
    <template #title> {{ t('modules.motionAnalyzer.index') }} </template>
  </base-module>
</template>

<script setup lang="ts">
import BaseModule from './BaseModule.vue'
import { useI18n } from 'vue-i18n'
import { useDeviceStore } from '@/store/deviceStore'
import { storeToRefs } from 'pinia'

const { t } = useI18n()
const deviceStore = useDeviceStore()
const { motorStatus } = storeToRefs(deviceStore)
</script>

<style lang="scss" scoped></style>
